import { Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { StyledHelpIconButton } from "./styles";

type Props = {
    href: string;
};

export const AgentHelpLink = ({ href }: Props) => (
    <Tooltip
        placement="bottom"
        content={translate("learn.more")}
    >
        <a
            target="_blank"
            rel="noreferrer"
            href={href}
        >
            <StyledHelpIconButton
                type="flat"
                iconSize="sm"
                iconName="learning-hat"
                data-automation="agent-help-link"
            />
        </a>
    </Tooltip>
);
